import dayjs from 'dayjs';
import { useConfig } from '../hooks/useConfig';
import type { CashflowForecastApiResponse } from '../pages/cashflow-forecast-dashboard/types';
import { http, type ExtendedAxiosRequestConfig } from './client';

type CashflowForecastEnv = 'dev' | 'test';

interface CashflowForecastGlobalConfig {
  env?: string;
  cashflowForecastScenarioOntologyIds?: Partial<
    Record<CashflowForecastEnv, number>
  >;
}

const DEFAULT_CASHFLOW_FORECAST_SCENARIO_ONTOLOGY_IDS: Record<
  CashflowForecastEnv,
  number
> = {
  dev: 190,
  test: 211,
};

export interface RunCashflowForecastPayload {
  场景本体ID: number;
  风险预测截至日期: string;
  预测截至日期: string;
}

export interface RunCashflowForecastParams {
  predictionEndDate: string;
}

const getCashflowForecastScenarioOntologyId = (): number => {
  // 如果跳转路径中携带ontologyId，使用携带的参数
  const urlParams = new URLSearchParams(window.location.search);
  const ontologyIdFromUrl = urlParams.get('ontologyId');
  if (ontologyIdFromUrl) {
    const parsedId = Number(ontologyIdFromUrl);
    if (!Number.isNaN(parsedId)) {
      return parsedId;
    }
  }

  const { globalConfig } = useConfig();
  const typedGlobalConfig = globalConfig as CashflowForecastGlobalConfig;
  const env: CashflowForecastEnv =
    typedGlobalConfig.env === 'test' ? 'test' : 'dev';
  const scenarioOntologyIds =
    typedGlobalConfig.cashflowForecastScenarioOntologyIds;

    console.log('ENV_VALUE', typedGlobalConfig.env, scenarioOntologyIds, globalConfig);

  return (
    scenarioOntologyIds?.[env] ||
    scenarioOntologyIds?.dev ||
    DEFAULT_CASHFLOW_FORECAST_SCENARIO_ONTOLOGY_IDS[env]
  );
};

const buildRunCashflowForecastPayload = (
  predictionEndDate: string
): RunCashflowForecastPayload => {
  return {
    场景本体ID: getCashflowForecastScenarioOntologyId(),
    风险预测截至日期: dayjs().add(180, 'day').format('YYYY-MM-DD'),
    预测截至日期: predictionEndDate,
  };
};

export async function runCashflowForecast({
  predictionEndDate,
}: RunCashflowForecastParams): Promise<CashflowForecastApiResponse> {
  const response = await http.post<CashflowForecastApiResponse>(
    '/ai-api/holon/v1/processes/orchestrator/blocking',
    buildRunCashflowForecastPayload(predictionEndDate),
    { useAuthToken: true } as ExtendedAxiosRequestConfig
  );

  return response.data;
}
